// extracted by mini-css-extract-plugin
export var colorSquare = "_u8-0";
export var danger = "_u8-5";
export var lightPink = "_u8-8";
export var neutralBlue = "_u8-7";
export var neutralYellow = "_u8-6";
export var normal = "_u8-1";
export var primary = "_u8-2";
export var primaryLight = "_u8-3";
export var solidBlack = "_u8-g";
export var solidGreen = "_u8-b";
export var solidLightBlue = "_u8-d";
export var solidNavy = "_u8-c";
export var solidOrange = "_u8-f";
export var solidPink = "_u8-e";
export var solidRed = "_u8-9";
export var solidYellow = "_u8-a";
export var success = "_u8-4";